export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-shield-check-line text-xl"></i>
              </span>
              <span className="leading-tight">
                <span className="block font-heading font-bold text-lg">求真核查站</span>
                <span className="block mt-0.5 text-xs text-background-100/70">
                  在线黑料事实核查
                </span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-100/75">
              让每一条在线黑料先求证、再转发。我们坚持多方求证与信息源核对，辟谣与证据梳理永久留档。
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-background-100/60">
              <i className="ri-message-2-line"></i>
              每周更新核查进度
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50">内容栏目</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-100/75">
              <li><a className="hover:text-accent-300 transition-colors" href="#columns">真假鉴定</a></li>
              <li><a className="hover:text-accent-300 transition-colors" href="#columns">事实核查</a></li>
              <li><a className="hover:text-accent-300 transition-colors" href="#columns">多方求证</a></li>
              <li><a className="hover:text-accent-300 transition-colors" href="#columns">可信度分析</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-100/75">
              <li><a className="hover:text-accent-300 transition-colors" href="#reports">最新核查结论</a></li>
              <li><a className="hover:text-accent-300 transition-colors" href="#debunk">辟谣专区</a></li>
              <li><a className="hover:text-accent-300 transition-colors" href="#method">核查流程</a></li>
              <li><a className="hover:text-accent-300 transition-colors" href="#faq">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-100/75">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-300"></i>
                contact@qiuzhen-hecha.example
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-focus-3-line text-accent-300 mt-0.5"></i>
                支持站内线索投稿与复核反馈
              </li>
            </ul>
            <a
              href="#contact"
              className="mt-4 inline-flex items-center gap-2 rounded-md bg-accent-500 hover:bg-accent-400 text-primary-950 px-4 py-2 text-sm font-semibold whitespace-nowrap transition-colors"
            >
              <i className="ri-send-plane-line"></i>
              提交线索
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/60">
            本站致力于信息求真与辟谣，内容仅供核实参考，不针对任何个人或组织进行负面评价。
          </p>
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} 求真核查站 · 理性看待每一条在线黑料
          </p>
        </div>
      </div>
    </footer>
  );
}